// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".core-title{display:grid;place-items:center;font-weight:100}.core-title h1{font-size:32px;line-height:44px;color:#373a36}.core-title a{color:#373a36;text-decoration:none}.core-title a:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
